<div class="top">
  <div class="heading">
   <span>Add New Privilege</span>
  </div>
  <i class="material-icons text-danger" role="button" (click)="closeModal()">
    close
  </i>
</div>

<div class="form-wrapper">
  <form [formGroup]="privilegeManagementForm" (ngSubmit)="openConfirmModal()">
    <div class="form-fields">
      <div class="field">
        <label for="name" class="required">Privilege Name</label>
        <input
          id="name"
          type="text"
          formControlName="name"
          class="form-control"
          placeholder="e.g., Admin"
          maxlength="40"
        />
      </div>

      <div class="field">
        <label for="name" class="required">Description</label>
        <input
          id="description"
          type="text"
          formControlName="description"
          class="form-control"
          placeholder="e.g., Admin with full access"
          maxlength="65"
        />
      </div>


    </div>

    <div class="modal-actions-wrapper">
      <button
        type="submit"
        class="custom-btn-primary w-100"
        [disabled]="
          !privilegeManagementForm.dirty ||
          privilegeManagementForm.invalid
        "
      >
        <ng-container *ngIf="!isSubmitting; else loadingTemplate">
          <span>Save</span>
        </ng-container>
        <ng-template #loadingTemplate>
          <span>Loading...</span>
        </ng-template>
      </button>


    </div>
  </form>
</div>
